import { Logout } from "@modules/auth/components/Logout";
import { protectedRoutes } from "@core/routing/helper-components/Routes";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { NavItem } from "./NavItem";
import { SidebarDrawer } from "./SidebarDrawer";
import { useAbility } from "@core/casl-provider";

interface SidebarProps {
  open: boolean;
  onToggle: () => void;
  isMobileView: boolean;
}

const Sidebar = ({ open, isMobileView, onToggle }: SidebarProps) => {
  const location = useLocation();
  const { user } = useAbility();

  // Filter routes that should be shown in the sidebar
  const menuItems = protectedRoutes.filter((route) => {
    if (!route.showInSidebar) return false;

    // Only show role-management route for admin users
    if (route.path === "/role-management") {
      return user?.role === "admin";
    }

    return true;
  });

  // To allow active menu styling as per selected route
  const isActive = (path: string) => {
    return (
      location.pathname === path ||
      (path !== "/" && location.pathname.startsWith(path))
    );
  };

  const handleNavItemClick = () => {
    // Close the sidebar on mobile when an item is clicked
    if (isMobileView) {
      onToggle();
    }
  };

  return (
    <SidebarDrawer
      open={open}
      onToggle={onToggle}
      isMobileView={isMobileView}
      footerContent={
        <Box sx={{ p: 1 }}>
          <Logout />
        </Box>
      }
    >
      {menuItems.map((route) => (
        <NavItem
          key={route.path}
          route={route}
          isOpen={open}
          isActive={isActive(route.path)}
          onClick={handleNavItemClick}
        />
      ))}
    </SidebarDrawer>
  );
};

export default Sidebar;
